export class SessionStoreData {
  id: string;
  sn: string;
  constructor(id: string, sn: string) {
    this.id = id;
    this.sn = sn;
  }
}
